import { useState, useEffect } from "react";
import { useMsal } from "@azure/msal-react";
import { loginRequest } from "authConfig";
import { callMsGraph } from "hooks/callMsGraph";
import appConfig from "appConfig";

const useFetchTenantName = () => {
  const { instance, accounts, inProgress } = useMsal();
  const [userInfo, setUserInfo] = useState(() => {
    // Attempt to load cached data from sessionStorage on initial load
    const cachedData = sessionStorage.getItem("userInfo");
    return cachedData
      ? JSON.parse(cachedData)
      : { displayName: "", tenantName: "", tenantId: "" };
  });
  useEffect(() => {
    if (inProgress === "startup" || !instance || accounts.length === 0) {
      return;
    }

    const fetchUserAndTenantInfo = async () => {
      try {
        const response = await instance.acquireTokenSilent({
          ...loginRequest,
          account: accounts[0],
        });
        const accessToken = response.accessToken;

        // Fetch user information
        const userResponse = await callMsGraph(
          accessToken,
          `${appConfig.microsoftGraphBaseUrl}/me`
        );

        // Fetch tenant information
        const orgResponse = await callMsGraph(
          accessToken,
          `${appConfig.microsoftGraphBaseUrl}/organization`
        );

        const organization = orgResponse.value && orgResponse.value[0];
        if (userResponse && organization) {
          const data = {
            displayName: userResponse.displayName,
            tenantName: organization.displayName,
            tenantId: organization.id,
          };
          sessionStorage.setItem("userInfo", JSON.stringify(data)); // Cache fetched data
          setUserInfo(data);
        } else {
          console.error(
            "Invalid user or organization response:",
            userResponse,
            orgResponse
          );
        }
      } catch (error) {
        console.error("Error fetching user and organization details:", error);
      }
    };
    fetchUserAndTenantInfo();
  }, [instance, accounts, inProgress]);

  return userInfo;
};

export default useFetchTenantName;
